import React from 'react'
import offer from '../assets/offer.png'
import map from '../assets/map.png'
import rac from '../assets/rak.png'
import Modal from '../Modal'
import { SliderAboutBookReview } from '../AllSliders/SliderAboutBookReview'
 
const BookCourtComp = () => {
    return (     
        <>
            <div>
                <div>
                    <div className='book-court-bg rounded-xl mt-4 md:mt-5 md:h-[20rem] h-[100px] w-[92%] mx-auto  '>
                        
                    </div>
                    <div className='book-bg-wrap  md:w-[80%] mx-auto -mt-8 md:-mt-14 '>
                            <h1 className='text-[#FBFEFF] ml-6 md:text-[32px] font-bold text-lg float-left  align-baseline '>Frank's Court</h1>
                            <p className='text-[#FBFEFF] text-sm mr-7   md:text-lg   cursor-pointer  float-right  pointer-cursor '> <u> view court images</u></p>
                        </div>
                    {/* bg end */}


                    <div className='md:w-[77%] mx-3 mt-9 md:mt-20 md:mx-auto'>
                        <div className='md:flex'>
                                 

                                 {/* book court left */}

                            <div className='book-court-left order-1 md:w-[60%] w-[95%] mx-auto'>
                                <div>
                                    <div cl>
                                        <h1 className='text-[18px] text-[#272C34]  font-bold'>About Court</h1>
                                        <p className='text-gray-400 text-[12px] text-[#6A7D95] '>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                            Vestibulum nunc metus, mattis quis nibh eget, vulputate ultrices est.
                                            Cras ipsum sapien, malesuada nec sagittis id, convallis quis purus.
                                            Cras faucibus risus gravida libero vestibulum, nec viverra risus ultricies.</p>
                                    </div>
                                    {/* offer  */}
                                    <div>
                                        <h1 className='text-[18px] text-[#272C34] font-bold py-2 mt-3'>Offered by</h1>
                                        <div className='flex justify-between border border-gray-300 rounded-xl py-8 px-6'>
                                            <div className='flex'>
                                                <img src={offer} alt='image' />
                                                <h1 className='px-3 pt-5 text-[18px] text-[#272C34] font-bold'>Padel co.ltd</h1>
                                            </div>
                                            <div>
                                                <p className='text-[12px] text-[#409BF5] font-bold pt-5 cursor-pointer px-3'>view company</p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* location   */}
                                    <div>
                                        <h1 className='text-[18px] text-[#272C34] font-bold py-4 '>Location</h1>
                                        <div className=' border border-gray-300 rounded-xl  '>
                                            <img src={map} alt='img' className='w-full' />
                                        </div>
                                    </div>

                                    {/* service */}
                                    <div>
                                        <h1 className='text-[18px] text-[#272C34] py-3 mt-4'><strong>Services </strong></h1>
                                        <div className='flex justify-between md:ml-8 md:w-[50%] '>
                                            <div>
                                                <ul className='text-[#6A7D95] text-[12px] font-semibold  '>
                                                    <li>Service name</li>
                                                    <li>Service name</li>
                                                    <li>Service name</li>
                                                </ul>
                                            </div>
                                            <div>
                                                <ul className='text-[#6A7D95] text-[12px] font-semibold' >
                                                    <li>Service name</li>
                                                    <li>Service name</li>
                                                    <li>Service name</li>

                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    {/* thought  */}
                                    <div>
                                        <h1 className='text-[18px] text-[#272C34] font-bold py-6 '>Thoughts about the court</h1>
                                        <div className='flex   bg-[#f4f8fa] rounded-xl py-3 md:px-6 px-3'>
                                            <div className=' md:w-[40%] w-[60%]  py-3'>

                                                <h1 className='  pt-3 font-bold text-[26px] text-gray-600'>5/5</h1>

                                                <form className='my-3 mx-auto'>

                                                    <i class="fa-solid fa-star text-xl   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-xl   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-xl   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-xl   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-xl   text-blue-500"></i>

                                                </form>

                                                <p className='text-gray-400 text-sm'>14 Ratnings</p>
                                            </div>
                                            <div className='w-full md:ml-32'>


                                                <div className='flex w-full py-1'>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <div className='  md:w-[40%] w-[80%] '>
                                                        <div class=" flex bg-gray-200 mx-4 mt-3 rounded-full  dark:bg-gray-700">
                                                            <div class="bg-blue-600 h-[3px] rounded-full w-[100%]">  </div>
                                                             
                                                        </div>
                                                    </div>
                                                    <p className='text-[12px] text-[#6A7D95]     '>14</p>
                                                </div>
                                                <div className='flex w-full py-1'>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-regular fa-star text-base   text-blue-500"></i>
                                                    <div className=' md:w-[40%] w-[80%]'>
                                                        <div class=" flex bg-gray-400 mx-4 mt-3 rounded-full dark:bg-gray-700">
                                                            <div class="h-[3px] rounded-full  ">  </div>
                                                        </div>
                                                    </div>
                                                    <p className='text-[12px] text-[#6A7D95]     '> </p>
                                                </div>
                                                <div className='flex w-full py-1'>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-regular fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-regular fa-star text-base   text-blue-500"></i>
                                                    <div className=' md:w-[40%] w-[80%]'>
                                                        <div class=" bg-gray-400 mx-4 mt-3 rounded-full  dark:bg-gray-700">
                                                            <div class="h-[3px] rounded-full  ">  </div>
                                                        </div>
                                                    </div>
                                                    <p className='text-[12px] text-[#6A7D95]    '> </p>
                                                </div>
                                                <div className='flex w-full py-1'>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-regular fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-regular fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-regular fa-star text-base   text-blue-500"></i>
                                                    <div className=' md:w-[40%] w-[80%]'>
                                                        <div class=" bg-gray-400 mx-4 mt-3 rounded-full dark:bg-gray-700">
                                                            <div class="h-[3px] rounded-full  ">  </div>
                                                        </div>
                                                    </div>
                                                    <p className='text-[12px] text-[#6A7D95]    '> </p>
                                                </div>
                                                <div className='flex w-full py-1'>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-regular fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-regular fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-regular fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-regular fa-star text-base   text-blue-500"></i>
                                                    <div className=' md:w-[40%] w-[80%]'>
                                                        <div class=" bg-gray-400 mx-4 mt-3 rounded-full dark:bg-gray-700">
                                                            <div class="h-[3px] rounded-full  ">  </div>
                                                        </div>
                                                    </div>
                                                    <p className='text-[12px] text-[#6A7D95]    '> </p>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    {/* prefect court management */}

                                    {/* <div className=' '>

                                        <div className='  border-4 my-4 border-gray-200 rounded-xl py-11 px-6'>
                                            <div className=''>
                                                <form className='my-2 mx-auto'>

                                                    <i class="fa-solid fa-star text-xl   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-xl   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-xl   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-xl   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-xl   text-blue-500"></i>

                                                </form>
                                                <h1 className='text-[18px] text-[#272C34] font-bold'>Perfect court management</h1>
                                            </div>
                                            <div>
                                                <p className='text-[#272C34]  pt-5 text-[12px]'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                            Vestibulum nunc metus, mattis quis nibh eget, vulputate ultrices est.
                                            Cras ipsum sapien, malesuada nec sagittis id, convallis quis purus.
                                            Cras faucibus risus gravida libero vestibulum, nec viverra risus ultricies.</p>
                                            </div>
                                            <div className=''>
                                                <p className='text-gray-500 float-right italic pt-5 text-sm'>    John Doe</p>
                                            </div>
                                        </div>
                                    </div> */}

                                    <SliderAboutBookReview/> 



                                </div>
                            </div>













                                {/* book right side */}

                            <div className='book-court-right order-2 mx-4 md:w-[40%]'>
                                <div className='border border-gray-300 w-full h-auto rounded-xl'>
                            <div>
                                <center>
                                    <h1 className='text-gray-800 text-[24px] text-[#272C34] font-bold'>$ 67.90 <span className='text-gray-500 text-sm'>/game/player</span></h1>
                                    <h1 className='text-[#6A7D95] font-normal text-[12px] py-3'>One game can be of maximum 1 hour </h1>
                                </center>
                            </div>


                          {/* Book your seat right */}

                <div>
                    <div>
                    <h1 className=' font-bold text-[12px] text-[#272C34] px-6'>Book your seat</h1>
                    <h1 className=' font-normal text-[12px] text-[#0F6BDF] py-2 px-6'>2 seats are available</h1>
                    </div>
                </div>
                
                <div className='w-full mt-4 '>
                    <div className='w-full bg-blue-400 h-[12rem]'>

                    <center>
                    <span className='h-[12rem]  w-1 bg-blue-900 border-2 border-blue-900 absolute '></span>
                    </center>

                    <div className='border border-white reltive h-[6rem] w-[80%] mx-auto'>
                    <div className='flex px-14 mt-7 justify-between'>
                    <div className='h-9 w-9  p-2  cursor-pointer  rounded-full bg-[#50DC8A] hover:bg-[#7bf9af] '>
                        <img src={rac} alt='img' className='absolute' />
                        </div>
                        <div className='h-9 w-9  p-2 cursor-pointer rounded-full bg-[#9A5C5C] hover:bg-[#ab7373]'>
                        <img src={rac} alt='img' className='absolute' />
                        </div>
                    </div>

                    
                    </div>
                    
                    
                    <div className='border border-white h-[97px] w-[80%] mx-auto'>
                    <div className='flex px-14 mt-8 justify-between'>
                    <div className='h-9 w-9  p-2   cursor-pointer rounded-full bg-gray-50 hover:bg-[#cdcdcd]'>
                        <img src={rac} alt='img' className='absolute' />
                        </div>
                        <div className='h-9 w-9  p-2 cursor-pointer rounded-full bg-gray-50 hover:bg-[#cdcdcd]'>
                        <img src={rac} alt='img' className='absolute' />
                        </div>
                    </div>
                    </div>
                    
                    </div>
                </div>

                {/* dots */}

                <div className='mx-10 my-2'>
                    <div className='justify-between flex'>
                    <div className='flex'>
                        <span className='rounded-full w-3 h-3 mt-1 bg-[#6A7D95]  '></span> <h1 className=' px-2 text-[#6A7D95] font-bold text-[12px] '>Available</h1>
                    </div>
                    <div className='flex'>
                        <span className='rounded-full w-3 h-3 mt-1 bg-[#9A5C5C]  '></span> <h1 className=' px-2 text-[#9A5C5C] font-bold text-[12px] '>Booked</h1>
                    </div>
                    <div className='flex'>
                        <span className='rounded-full w-3 h-3 mt-1 bg-[#50DC8A]  '></span> <h1 className=' px-2 text-[#50DC8A] font-bold text-[12px] '>Selected</h1>
                    </div>
                    </div>
                </div>

                {/* No seats */}
                <div>
                <h1 className='text-[12px] py-4 font-bold px-8 text-[#272C34]'>No. of seats</h1>
                <form class=" rounded  mb-4">
                <div class="mb-4 mx-8 flex">
 
                 <input class="shadow  bg-[#FBFEFF] appearance-none border border-gray-300 rounded-xl w-full  h-[32px] text-xs px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="username" type="text" value='1'/>
                 <div className='flex h-[31px] bg-gray-200   rounded-r-xl -ml-[83px]'>
                  
                  <button className=' '> <i class=" fa-solid fa-minus text-xl px-3 active:text-blue-300"></i></button> <button className=' text-xl'><i class=" fa-solid fa-plus px-3 active:text-blue-300 "></i></button>
                  </div>
                 </div>
                  </form>
                </div>

                {/* Select date */}
                <div>
                <h1 className=' py-4 px-8 text-[12px] font-bold text-[#272C34]   '>Select date</h1>
                <form class="  rounded  mb-4">
                <div class="mb-4 mx-8 flex ">
 
                 <input class="shadow bg-[#FBFEFF]  border border-gray-300 appearance-none border text-gray-600 rounded-xl w-full h-[32px]  px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="username" type="date"  />
 
                 </div>
                  </form>
                </div>

                {/* select time slot */}

                  
                  <div className='charge   mb-4  mx-8  my-2 p-5'>
                            <div>
                                <h2 className='text-[12px] font-bold text-[#272C34]  '>Select Availabe time slot</h2>
                            </div>
                            <div>

                                <form className='my-3'>

                                    <div className="  md:items-center mb-1">
                                        <label className="md:w-2/3 block text-gray-500 font-bold">
                                            <input className="mr-2 h-[15px]  w-[15px] leading-tight" type="checkbox" />
                                            <span className="text-[12px] text-[#6A7D95]">
                                               11 : 00 AM - 12 : 00 PM
                                            </span>
                                        </label>
                                    </div>

                                    <div className="  md:items-center mb-1">
                                        <label className="md:w-2/3 block text-gray-500 font-bold">
                                            <input className="mr-2 h-[15px] w-[15px] leading-tight" type="checkbox" />
                                            <span className="text-[12px] text-[#6A7D95]">
                                            11 : 00 AM - 12 : 00 PM
                                            </span>
                                        </label>
                                    </div>

                                    <div className="  md:items-center mb-1">
                                        <label className="md:w-2/3 block text-gray-500 font-bold">
                                            <input className="mr-2 h-[15px] w-[15px] leading-tight" type="checkbox" />
                                            <span className="text-[12px]   text-[#6A7D95]">
                                            11 : 00 AM - 12 : 00 PM
                                            </span>
                                        </label>
                                    </div>

                                </form>
                            </div>
                        </div>

                        {/* book now model button  */}
                        <div>
                            <div>
                        
                     <Modal/> 

                            </div>
                        </div>

                
                    </div>




  {/* links div start */}
  <div className='charge border my-7 border-gray-300 rounded-xl mx-2 '>

           <div className='flex justify-between py-5 border-b border-gray-300'> 
               <h2 className='text-[12px] cursor-pointer text-[#009FD9] font-bold pl-4  '>https//:padelcompany.com/</h2>
               <i class="fa-solid fa-diamond-turn-right h-[16px] w-[16px] pr-8   text-[#009FD9]"></i>
            </div>
            <div className='flex justify-between py-5 border border-b-gray-300'> 
               <h2 className='text-[12px] cursor-pointer text-[#009FD9] font-bold pl-4  '>https//:padelcompany.com/</h2>
               <i class="fa-solid fa-arrow-up-right-from-square h-[16px] w-[16px] pr-8   text-[#009FD9]"></i>
            </div>
            <div className='flex justify-between py-5 border border-b-gray-300'> 
               <h2 className='text-[12px] cursor-pointer text-[#009FD9] font-bold pl-4  '>https//:padelcompany.com/</h2>
               <i class="fa-solid fa-envelope h-[16px] w-[16px] pr-8   text-[#009FD9]"></i>
            </div>
            <div className='flex justify-between py-5   border-t border-gray-300'>  
               <h2 className='text-[12px] cursor-pointer text-[#009FD9] font-bold pl-4  '>https//:padelcompany.com/</h2>
               <i class="fa-solid fa-phone h-[16px] w-[16px] pr-8   text-[#009FD9]"></i>
            </div>
            

                            <div>

                                
                            </div>
   </div>


                        {/* Links div end */}




                            </div>














                        </div>
                    </div>







                </div>
            </div>

            {/* <div class="divider div-transparent div-arrow-down"></div> */}
        </>
    )
}

export default BookCourtComp